import { Button as GardenButton } from "@zendeskgarden/react-buttons";
import type { PropsButton } from "./interface";


export function Button({ children, onClick, disabled, isDanger, isPrimary, isBasic, isStretched }: PropsButton) {
    return (
        <GardenButton
            disabled={disabled}
            isStretched={isStretched}
            onClick={onClick}
            isDanger={isDanger}
            isPrimary={isPrimary}
            isBasic={isBasic}
        >
            {children}
        </GardenButton>
    );
}